// Stub for server-only packages transitively imported by @buildwithflux/core.
// These are dead code in the browser bundle (tree-shaken away).
export default {};
